import { SimpleAlert } from "../components/Alerts/Alerts";
import {
  OK,
  OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT,
  OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE,
} from "../i18n/keysTranslations";
import { ALERT_ICON_TYPE_SUCCESS } from "./constants";

export const showPlatformConnectedAlert = async ({ t }) => {
  await SimpleAlert({
    title: t(OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE),
    text: t(OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT),
    icon: ALERT_ICON_TYPE_SUCCESS,
    confirmButtonText: t(OK),
  });
};
